/**
 * @param {number|string} value
 * @param {number|string} percent
 * @return {number}
 */
export function setValueFromPercent(value, percent) {
  return parseInt(parseInt(value) * parseFloat(percent / 100).toFixed(2))
}
